// Two cheap bot checks for public forms, read by the backend (routes/leads.py _bot_reason):
//   hp  a field placed off-screen. People never see it; form-filling bots fill every field they find.
//   ms  time from the form appearing to being sent. A person needs more than a second and a half.
// A bot that trips either still gets the normal "thanks", so it has nothing to learn from.
import { useRef, useState } from 'react';

export function useBotTrap() {
  const shown = useRef(Date.now());
  const [hp, setHp] = useState('');
  const trapField = (
    <input
      type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true"
      value={hp} onChange={(e) => setHp(e.target.value)}
      style={{ position: 'absolute', left: '-10000px', width: 1, height: 1, opacity: 0 }}
    />
  );
  return { trapField, trapMeta: () => ({ hp, ms: Date.now() - shown.current }) };
}
